import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useSetState } from "Helpers/Hooks";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";

const CutList = () => {
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [showSelect, setShowSelect] = useState(true);
  const [controls, setControls] = useSetState({
    action: {
      type: "radio",
      value: { value: 1, key: "LinedProfile" },
      items: [
        { value: 1, key: "LinedProfile" },
        { value: 30, key: "UnitedProfile" },
        { value: 5, key: "Net" },
        { value: 2, key: "Glass" },
        { value: 3, key: "glass_excel_file" },
      ],
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, key: "isFrame" },
        { value: false, key: "isSash" },
        { value: false, key: "isSashDoor" },
        { value: false, key: "isMulion" },
        { value: false, key: "isGlazing" },
        { value: false, key: "isRokob" },
        { value: false, key: "isInterLock" },
        { value: false, key: "isConectorSash" },
        { value: false, key: "isOtherPop" },
        { value: false, key: "isOtherRail" },
        { value: false, key: "isPanel" },
        { value: false, key: "isProfileKomaki" },
      ],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        Extra_CutList: value,
        action: value.value,
      },
    });
    if ([1, 30].includes(value.value)) {
      setShowSelect(true);
    } else {
      setShowSelect(false);
    }
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        [key]: e.currentTarget.checked,
      },
    });
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    let selected = {};
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          selected[inner.key] = true;
          return inner;
        }),
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        ...selected,
      },
    });
  };

  const onClear = () => {
    const constructGlass = read("constructGlass");
    if (constructGlass == null) {
      setControls({
        action: {
          type: "radio",
          value: { value: 2, key: "Glass" },
          items: [
            { value: 2, key: "Glass" },
            { value: 3, key: "glass_excel_file" },
          ],
        },
      });
      setShowSelect(false);
    } else {
      setControls({
        action: {
          type: "radio",
          value: constructionResult.Extra_CutList,
          items: [
            { value: 1, key: "LinedProfile" },
            { value: 30, key: "UnitedProfile" },
            { value: 5, key: "Net" },
            { value: 2, key: "Glass" },
            { value: 3, key: "glass_excel_file" },
          ],
        },
      });
      setShowSelect([1, 30].includes(constructionResult.Extra_CutList.value));
    }
    setControls({
      checkbox: {
        items: [
          { value: constructionResult.isFrame, key: "isFrame" },
          { value: constructionResult.isSash, key: "isSash" },
          { value: constructionResult.isSashDoor, key: "isSashDoor" },
          { value: constructionResult.isMulion, key: "isMulion" },
          { value: constructionResult.isGlazing, key: "isGlazing" },
          { value: constructionResult.isRokob, key: "isRokob" },
          { value: constructionResult.isInterLock, key: "isInterLock" },
          { value: constructionResult.isConectorSash, key: "isConectorSash" },
          { value: constructionResult.isOtherPop, key: "isOtherPop" },
          { value: constructionResult.isOtherRail, key: "isOtherRail" },
          { value: constructionResult.isPanel, key: "isPanel" },
          { value: constructionResult.isProfileKomaki, key: "isProfileKomaki" },
        ],
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        action: constructionResult.Extra_CutList.value,
        pageIndex: 150,
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  return (
    <>
      <Grid container className="p-3">
        <Grid item xs={12}>
          <MuiRadioGroup
            name="action"
            value={controls.action.value}
            items={controls.action.items}
            onChange={onChangeRadio}
            translate={true}
            className="horizontalRadio"
          />
        </Grid>
        {showSelect && (
          <Grid item xs={12} className="mt-2">
            <MuiCheckBoxGroup
              label={<Translator id={"selectProfile"} />}
              name="checkbox"
              value={controls.checkbox.value}
              items={controls.checkbox.items}
              onChange={onChangeCheckbox}
              translate={true}
              selectAllShow
              onSelectAll={onChangeCheckbox_SelectAll}
              className="horizontalCheckbox mt-3"
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default CutList;
